// Lets pages tell the Layout shell that stored instance info changed
// (save/rename), so the sidebar profile item and exit dialog stay fresh.
export const INSTANCE_INFO_CHANGED = 'alchemist:instance-info-changed';

export const notifyInstanceInfoChanged = () =>
  window.dispatchEvent(new Event(INSTANCE_INFO_CHANGED));
